export const BrandName = "Sway";
export const AppName = "Track Your Package";
